import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import * as T from '../Typography';
import Icon from '../Icon';

import * as S from './style';

const GoBack = ({
  color = 'primaryMain',
  customFn,
  customLink,
  text,
  icon,
  width,
  height,
  ...props
}) => {
  const navigate = useNavigate();
  const goBack = () => {
    if (customLink) {
      navigate(customLink);
    } else if (customFn && typeof customFn === 'function') {
      customFn();
    } else if (window.history.length === 1) {
      // If history is empty, redirect to '/'
      navigate('/');
    } else {
      navigate(-1);
    }
  };

  return (
    <S.Wrapper onClick={goBack} color={color} {...props}>
      <Icon
        icon={icon || 'goBack'}
        width={width || 35}
        height={height | 11}
        color={color}
        pointer
      />
      {text && (
        <T.P bold ml="1" as="span" color={color}>
          {text}
        </T.P>
      )}
    </S.Wrapper>
  );
};

GoBack.propTypes = {
  color: PropTypes.string,
  text: PropTypes.string,
};

export default GoBack;
